document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".custom-signup__form");
  const submitButton = form.querySelector(".btn.submit-signup");
  const marketingCheckbox = document.querySelector("#contact-marketing-opt-in");
  const emailInput = document.querySelector("#contact-email");
  const firstNameInput = document.querySelector("#contact-first-name");
  const lastNameInput = document.querySelector("#contact-last-name");
  const phoneInput = document.querySelector("#contact-phone");
  const channelInputs = document.querySelectorAll(
    "input[name='contact[note][channel]']"
  );

  const requiredFields = [
    { input: firstNameInput, label: "First Name" },
    { input: lastNameInput, label: "Last Name" },
    { input: emailInput, label: "Email Address" },
  ];

  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    if (emailInput) {
      emailInput.value = email;
    }
  }

  function showError(inputField, labelText) {
    const parent = inputField.closest(".form__field");
    parent.classList.add("error");

    let errorMessage = parent.querySelector(".error-message");
    if (!errorMessage) {
      errorMessage = document.createElement("div");
      errorMessage.className = "error-message";
      errorMessage.textContent = `${labelText} is required.`;
      parent.appendChild(errorMessage);
    }
  }

  function clearError(inputField) {
    const parent = inputField.closest(".form__field");
    parent.classList.remove("error");

    const errorMessage = parent.querySelector(".error-message");
    if (errorMessage) {
      errorMessage.remove();
    }
  }

  function getSelectedValue(inputs) {
    for (const input of inputs) {
      if (input.checked) {
        return input.value;
      }
    }
    return null;
  }

  submitButton.addEventListener("click", function (event) {
    let isValid = true;

    requiredFields.forEach(({ input, label }) => {
      if (!input.value.trim()) {
        isValid = false;
        showError(input, label);
      } else {
        clearError(input);
      }
    });

    if (!marketingCheckbox.checked) {
      isValid = false;
      showError(marketingCheckbox, "Marketing consent");
    } else {
      clearError(marketingCheckbox);
    }

    if (!isValid) {
      event.preventDefault();
      return;
    }

    const phone = phoneInput.value.trim();
    const channel = getSelectedValue(channelInputs);

    const listId = "VC46Ex";
    const apiKey = "WjtZLX";

    const options = {
      method: "POST",
      headers: {
        revision: "2025-01-15",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailInput.value,
                  first_name: firstNameInput.value,
                  last_name: lastNameInput.value,
                  properties: {
                    phone: phone || "",
                    channel: channel || ""
                  },
                },
              },
            },
          },
          relationships: { list: { data: { type: "list", id: listId } } },
        },
      }),
    };

    fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`,
      options
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      })
      .then(() => {
        setTimeout(() => {
          window.location.href =
            "https://www.tpbmarketplace.ca/pages/thank-you-for-signing-up-to-our-newsletter";
        }, 500);
      })
      .catch((err) => console.error(err));
  });
});
